import React, { useState, useEffect, useRef } from "react";
import { useQuery } from "react-query";
import { useForm, Controller } from "react-hook-form";
import { withRouter } from "react-router-dom";
import { useStateValue } from "../../context/store";
import {
  Grid,
  TextField,
  FormControl,
  Typography,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  Button,
  Link,
  Input,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { styles } from "./styles";
import { finishCv } from "../../actions/cv-actions";
import { obtenerDataArhivo } from "../../actions/imagen-action";
import { getProfessions } from "../../actions/profession-actions";
import { getById } from "../../actions/user-actions";
import { getMaestras } from "../../actions/maestras-actions";
import Utils from "../../utils/utils";
import PublishIcon from "@material-ui/icons/Publish";
import { ColorButton, BorderRedButton } from "../../utils/form/buttonsForm";
import { defaultValues, childValues, experienceYears } from "./models";
import { Autocomplete } from "@material-ui/lab";
import { getCarrers } from "../../actions/dummy-actions";
import {
  getProvinces,
  getTownsByProvinceId,
} from "../../actions/location-actions";
import { getPersonByDocumentAndType } from "../../actions/user-actions";
import {
  FORMAT_MESSAGE,
  REQUIRED_MESSAGE,
  FORMAT_MESSAGE_CV,
  FORMAT_MESSAGE_PHOTO,
  SIZE_MESSAGE,
} from "../../constants";
import Title from "../../utils/form/title";
import { TextMaskCustom } from "./help";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";

const CvForm = (props) => {
  const [{ sessionUser, breadCrumb }, dispatch] = useStateValue();
  const [userSession, setUserSession] = useState(null);
  const [typeD, setTypeD] = useState(null);
  const [documentD, setDocumentD] = useState(null);
  const classes = styles();
  const [person, setPerson] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [tallaNumeros, setTallaNumeros] = useState([]);
  const [carrers, setCarrers] = useState([]);
  const [cities, setCities] = useState([]);
  const [departamento, setDepartamento] = useState();
  const [ciudad, setCiudad] = useState();
  const [deptos, setDeptos] = useState([]);
  const [isStateChange, setIsStateChange] = useState(false);
  const [showChildModal, setShowChildModal] = useState(false);
  const [kidsNumber, setKidsNumber] = useState(0);
  const [listChildren, setListChildren] = useState([]);
  const [listComplementaryStudies, setListComplementaryStudies] = useState([]);
  const [documentos, setDocumentos] = useState({
    imagenPerfil: null,
    fotoUrl: "",
    hojaVida: null,
    hojaVidaUrl: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [maestras, setMaestras] = useState({
    estadoCivil: [],
    generos: [],
    nivelFormacion: [],
    respuestaAfirmacionNegacion: [],
    tallaCalzado: [],
    tallaLetras: [],
    tallaNumerosFemenino: [],
    tallaNumerosMasculino: [],
    tipoDocumnetoIdentificacion: [],
  });
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    oneButtons: false,
    type: "",
    title: "",
    oneButtons: false,
  });

  const [maxDate, setMaxDate] = useState(
    Utils.getFormattedDateMMddyyyy(new Date(), ".")
  );

  let lastDay = new Date(new Date().getFullYear(), 11, 31);
  const [lastDayYear, setLastDayYear] = useState(
    Utils.getFormattedDateMMddyyyy(lastDay, ".")
  );
  const [minDate, setMinDate] = useState(null);
  const [showTelephoneMessage, setShowTelephoneMessage] = useState(false);
  const [showCellTelephoneMessage, setShowCellTelephoneMessage] =
    useState(false);
  const [telephoneMessage, setTelephoneMessage] = useState(
    "Ingrese mínimo 10 dígitos"
  );
  const [professions, setProfessions] = useState([]);
  const [validCv, setValidCv] = useState(true);
  const [validPhoto, setValidPhoto] = useState(true);
  const [validCvFormat, setValidCvFormat] = useState(true);
  const [validPhotoFormat, setValidPhotoFormat] = useState(true);
  const [validPhotoSize, setValidPhotoSize] = useState(true);
  const [validCvSize, setValidCvSize] = useState(true);
  const [errorStudios, setErrorEstudios] = useState([]);
  const [errorHijos, setErrorHijos] = useState([]);

  const createBtnContainer = useRef(null);
  const cancelBtnContainer = useRef(null);

  const getListaMaestras = async () => {
    const response = await getMaestras();
    getPersonByDocAndType(response.data.maestras);
    setMaestras(response.data.maestras);
    return response.data.maestras;
  };

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Hoja de vida",
      breadCrumbSubText: "Hoja de vida",
      index: 9,
      isEditCv: false,
      isCreateCv: true,
    });
    getListaMaestras();
  }, []);

  useEffect(() => {
    setCarrers(getCarrers());
  }, []);

  useEffect(() => {
    const getListProvinces = async () => {
      const response = await getProvinces();
      setDeptos(response.data.provinceList);
    };
    getListProvinces();

    const getListProfessions = async () => {
      const response = await getProfessions();
      setProfessions(response.data.professionList);
    };
    getListProfessions();
  }, []);

  const schema = yup.object().shape({
    firstName: yup
      .string()
      .nullable()
      .notRequired()
      .trim()
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido"),
    secondName: yup
      .string()
      .nullable()
      .notRequired()
      .trim()
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido")
      .transform((v) => (v ? v : null)),
    surname: yup
      .string()
      .nullable()
      .notRequired()
      .trim()
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un apellido válido"),
    secondSurname: yup
      .string()
      .nullable()
      .notRequired()
      .trim()
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido")
      .transform((v) => (v ? v : null)),
    dateBirth: yup.date().nullable().notRequired(),
    documentType: yup.string().nullable().notRequired(),
    documentNumber: yup.string().nullable().notRequired(),
    expeditionDate: yup
      .date()
      .required(REQUIRED_MESSAGE)
      .min(
        person?.dateBirth
          ? person.dateBirth
          : new Date(1900, 11, 31, 23, 59, 29),

        `No puede ser menor a la fecha de nacimiento`
      )
      .max(new Date(), `La fecha no puede ser mayor a la fecha actual`)
      .nullable()
      .typeError("Ingrese un formato de fecha válido"),
    gender: yup.string().nullable().notRequired(),
    phone: yup
      .string()
      .nullable()
      .transform((value) =>
        value
          .replace(/\s+/g, "")
          .split(" ")
          .join("")
          .replace("(", "")
          .replace(")", "")
          .replace("-", "")
          .replace(" ", "")
          .trim()
      )
      .required(REQUIRED_MESSAGE)
      .min(10, "Ingrese mínimo 10 dígitos"),
    cellPhoneNumber: yup
      .string()
      .nullable()
      .transform((value) =>
        value
          .replace(/\s+/g, "")
          .split(" ")
          .join("")
          .replace("(", "")
          .replace(")", "")
          .replace("-", "")
          .replace(" ", "")
          .trim()
      )
      .required(REQUIRED_MESSAGE)
      .min(10, "Ingrese mínimo 10 dígitos"),
    email: yup
      .string()
      .nullable()
      .email("Ingrese un correo electrónico válido")
      .notRequired(),
    stateId: yup.string().nullable().required(REQUIRED_MESSAGE),
    cityId: yup.string().nullable().required(REQUIRED_MESSAGE),
    shirtSize: yup.string().nullable().required(REQUIRED_MESSAGE),
    pantSize: yup.string().nullable().required(REQUIRED_MESSAGE),
    shoeSize: yup.string().nullable().required(REQUIRED_MESSAGE),
    maritalStatus: yup.string().nullable().required(REQUIRED_MESSAGE),
    numberChildren: yup.number().nullable().required(REQUIRED_MESSAGE),
    professionId: yup
      .object()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .shape({
        id: yup.string().required(REQUIRED_MESSAGE),
      }),
    levelEducation: yup.string().nullable().required(REQUIRED_MESSAGE),
    complementaryStudies: yup
      .string()
      .nullable()
      .notRequired()
      .trim()
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido")
      .transform((v) => (v ? v : null)),
    yearExpericence: yup.number().nullable().required(REQUIRED_MESSAGE),
    ownVehicle: yup.string().nullable().required(REQUIRED_MESSAGE),
    currentlyWorking: yup.string().nullable().required(REQUIRED_MESSAGE),
    fotoPerfil: yup.string().nullable().notRequired(),
    hojaVida: yup.string().nullable().notRequired(),
    estudios: yup.array().of(
      yup.object().shape({
        estudio: yup
          .string()
          .nullable()
          .notRequired()
          .trim()
          .min(5, "Ingrese mínimo 5 caracteres")
          .max(50, "Ingrese máximo 50 caracteres")
          .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido")
          .transform((v) => (v ? v : null)),
      })
    ),
  });

  const { register, handleSubmit, setValue, control, errors, getValues } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues,
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const setPersonData = (data, maestrasData) => {
    setValue(
      "cellPhoneNumber",
      Utils.padLeadingZeros(data.cellPhoneNumber, 10)
    );
    setValue("creationDate", data.creationDate);
    setValue("creationUser", data.creationUser);
    setValue("dateUpdate", data.dateUpdate);
    setValue("documentNumber", data.documentNumber);
    setValue("documentType", data.documentType);
    setValue("gender", data.domainGender);
    onGenderChange(data.domainGender, maestrasData);
    setValue("domainstatus", data.domainstatus);
    setValue("email", data.externalEmail);
    setValue("firstName", data.firstName);
    setValue("id", data.id);
    setValue("internalEmail", data.internalEmail);
    if (data.phone) {
      setValue("phone", Utils.padLeadingZeros(data.phone, 10));
    }
    setValue("secondName", data.secondName);
    setValue("secondSurname", data.secondSurname);
    setValue("surname", data.surname);
    data.dateBirth && setValue("dateBirth", data.dateBirth);
    data.dateBirth &&
      setMinDate(Utils.getFormattedDateMMddyyyy(new Date(data.dateBirth), "."));
    setValue("userEdit", data.userEdit);
  };

  const getPersonByDocAndType = (maestrasData) => {
    let personaResponse = null;

    const getPerson = async () => {
      const personResponse = await getPersonByDocumentAndType(
        personaResponse.data.documentNumber,
        personaResponse.data.documentType,
        dispatch
      );
      const personData = personResponse.data;
      setPersonData(personData, maestrasData);
      setPerson(personData);
      setIsLoading(false);
    };

    const getPersona = async () => {
      const data = JSON.parse(localStorage.getItem("state"));
      let personId = sessionUser && sessionUser.userInfo.person.id;
      let id = personId ? personId : data.userInfo.person.id;
      personaResponse = await getById(id, dispatch);

      setUserSession(personaResponse.data);
      setTypeD(personaResponse.data.documentType);

      setDocumentD(personaResponse.data.documentNumber);
      getPerson();
    };

    getPersona();
  };

  const closeMessage = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const buildCvObject = (data) => {
    let compStudies = data.complementaryStudies;
    if (listComplementaryStudies.length > 0) {
      let complementaryStudies = listComplementaryStudies.filter(function (
        str
      ) {
        return /\S/.test(str);
      });
      compStudies += compStudies
        ? `,${complementaryStudies.join()}`
        : `${complementaryStudies.join()}`;
    }

    if (data.expeditionDate) {
      data.expeditionDate.setHours(0, 0, 0, 0);
    }

    var cvObject = {
      person: {
        firstName: person.firstName,
        secondName: person.secondName,
        surname: person.surname,
        secondSurname: person.secondSurname,
        documentType: person.documentType,
        documentNumber: person.documentNumber,
        externalEmail: person.externalEmail,
        phone: data.phone ? data.phone : person.phone,
        cellPhoneNumber: data.cellPhoneNumber
          ? data.cellPhoneNumber
          : person.cellPhoneNumber,
        gender: data.gender ? data.gender : person.domainGender,
        creationUser: "DEV",
        dateBirth: person.dateBirth,
        password: "",
      },
      attachment: {
        cv: documentos.hojaVida.data,
        photo: documentos.imagenPerfil.data,
        photoExtension: documentos?.photoExtension.toUpperCase(),
      },
      province: departamento,
      town: ciudad,
      profession: data.professionId.id,
      numberChildren: data.numberChildren ? data.numberChildren : 0,
      listChildren: listChildren,
      shirtSize: data.shirtSize,
      pantSize: data.pantSize,
      shoeSize: data.shoeSize,
      documentIssueDate: data.expeditionDate,
      maritalStatus: data.maritalStatus,
      levelEducation: data.levelEducation,
      complementaryStudies: compStudies,
      yearsExperience: data.yearExpericence,
      ownVehicle: data.ownVehicle,
      currentlyWorking: data.currentlyWorking,
      userCreation: "DEV",
    };
    return cvObject;
  };

  const handleDepartamentos = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setCities([]);
    setTimeout(() => {
      if (value) {
        setDepartamento(value);
        const getListTowns = async () => {
          const response = await getTownsByProvinceId(value);
          setCities(response.data.townList);
        };
        getListTowns();
        setIsStateChange(true);
      } else {
        setIsStateChange(false);
      }
    }, 500);
  };

  const validateTelephoneNumber = (value, name) => {
    let valid = true;
    let telephoneNumber = value
      .replace(/\s+/g, "")
      .split(" ")
      .join("")
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "")
      .trim();
    if (telephoneNumber.length < 10) {
      name === "phone"
        ? setShowTelephoneMessage(true)
        : setShowCellTelephoneMessage(true);
      valid = false;
    } else {
      name === "phone"
        ? setShowTelephoneMessage(false)
        : setShowCellTelephoneMessage(false);
      valid = true;
    }
    return valid;
  };

  const onSubmit = (data) => {
    var validCellPhoneNumber = validateTelephoneNumber(
      data.cellPhoneNumber,
      "cellPhoneNumber"
    );
    var validPhoneNumber = validateTelephoneNumber(data.phone, "phone");
    var validateCv = documentos?.hojaVida?.data ? true : false;
    var validatePhoto = documentos?.imagenPerfil?.data ? true : false;
    setValidCv(validateCv);
    setValidPhoto(validatePhoto);
    var errorEstudios = false;
    let i = 0;
    for (const property in errorStudios) {
      if (errorStudios[property] === true) {
        errorEstudios = true;
      }
      i++;
    }

    var hasError = false;
    if (data.numberChildren > 0) {
      for (i = 0; i <= data.numberChildren - 1; i++) {
        let validateName = validateText(listChildren[i].name);
        if (validateName.hasError === true) {
          hasError = validateName.hasError;
        }
        setErrorHijos((errorHijos) => ({
          ...errorHijos,
          [`hijos[${i}]nombre`]: validateName.hasError,
          [`hijos[${i}]messageNombre`]: validateName.message,
        }));

        if (!listChildren[i].birthDate) {
          const validate = validateNullorEmpty(listChildren[i].birthDate);
          if (validate.hasError === true) {
            hasError = validate.hasError;
          }
          setErrorHijos((errorHijos) => ({
            ...errorHijos,
            [`hijos[${i}]fechaNacimiento`]: validate.hasError,
            [`hijos[${i}]messageFecha`]: validate.message,
          }));
        }
      }
    }

    if (
      !validateCv ||
      !validatePhoto ||
      errorEstudios ||
      hasError ||
      !validCellPhoneNumber ||
      !validPhoneNumber ||
      !validCvSize ||
      !validCvFormat ||
      !validPhotoFormat ||
      !validPhotoSize
    ) {
      return false;
    }

    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que desea crear el registro? ",
      handleClick: () => onSubmitFinalize(data),
      handleClickOut: closeModal,
      type: "QUESTION",
    }));
  };

  const onSubmitFinalize = (data) => {
    setIsLoading(true);
    var currentData = Utils.convertStringEmptyToNull(data);
    currentData = buildCvObject(currentData);

    var newData = { ...currentData };
    closeModal();

    finishCv(newData, dispatch).then((response) => {
      if (response && response.status >= 200 && response.status < 399) {
        setIsLoading(false);
        setConfirm({
          open: true,
          question: "Información registrada exitosamente",
          type: "SUCCESS",
          handleClick: gotoHome,
          oneButtons: true,
          handleClickOut: closeMessage,
        });
      } else {
        setIsLoading(false);
      }
      setTimeout(function () {
        setIsLoading(false);
      }, 2000);
    });
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const cancelConfirm = () => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que NO desea continuar creando el registro?",
      handleClick: cancel,
      handleClickOut: closeModal,
      type: "QUESTION",
    }));
  };

  const gotoHome = () => {
    props.history.push("/dashboard/home");
  };

  const cancel = () => {
    closeModal();

    setConfirm(() => ({
      open: true,
      question: "Registro cancelado",
      handleClick: gotoHome,
      oneButtons: true,
      type: "WARNING",
    }));
  };

  const onGenderChange = (value, maestrasData) => {
    let tallas =
      value === "MASCULINO"
        ? maestrasData.tallaNumerosMasculino
        : maestrasData.tallaNumerosFemenino;
    setTallaNumeros(tallas);
  };

  const onChangeGender = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setValue("pantSize", null);
    let tallas =
      value === "MASCULINO"
        ? maestras.tallaNumerosMasculino
        : maestras.tallaNumerosFemenino;
    setTallaNumeros(tallas);
  };

  // const onTelephoneChange = (e) => {
  //   e.preventDefault();
  //   const { value, name } = e.target;
  //   let telephoneNumber = value
  //     .replace("(", "")
  //     .replace(")", "")
  //     .replace("-", "")
  //     .replace(" ", "")
  //     .trim();
  //   if (parseInt(telephoneNumber) < 99999999) {
  //     name === "phone"
  //       ? setShowTelephoneMessage(true)
  //       : setShowCellTelephoneMessage(true);
  //   } else {
  //     name === "phone"
  //       ? setShowTelephoneMessage(false)
  //       : setShowCellTelephoneMessage(false);
  //   }
  // };

  const logicaHijos = (value) => {
    if (value === 0) {
      onClearChildData(value);
      return false;
    }
    if (value && (listChildren.length == 0 || value >= listChildren.length)) {
      setShowChildModal(true);
      var setFields = value - listChildren.length;
      var kids = [...Array(setFields)].map((e, i) => {
        return { name: null, birthDate: null };
      });
      setListChildren([...listChildren, ...kids]);
    } else {
      let currentLength = listChildren.length;
      listChildren.length = value;
      for (var i = value; i <= currentLength; i++) {
        delete errorHijos[`hijos[${i}]nombre`];
        delete errorHijos[`hijos[${i}]messageNombre`];
        delete errorHijos[`hijos[${i}]fechaNacimiento`];
        delete errorHijos[`hijos[${i}]messageFecha`];
      }
      setErrorHijos(errorHijos);
    }
  };

  const addComplementaryStudy = () => {
    setListComplementaryStudies([...listComplementaryStudies, ""]);
  };

  const onNumberChildrenChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setKidsNumber(value);
    logicaHijos(value);
  };

  const onClearChildData = (value) => {
    closeModal();
    setShowChildModal(true);
    setKidsNumber(value);
    setErrorHijos([]);
    var kids = [...Array(value)].map((e, i) => {
      return { name: null, birthDate: null };
    });
    setListChildren([...kids]);
  };

  const subirArchivo = (e) => {
    const { name, value, accept } = e.target;
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    const fileSize = file.size / 1024 / 1024; // in MiB
    //tamano
    if (fileSize > 5) {
      if (name === "fotoPerfil") {
        setValidPhotoSize(false);
      }
      if (name === "hojaVida") {
        setValidCvSize(false);
      }
      setConfirm(() => ({
        open: true,
        question: SIZE_MESSAGE,
        handleClick: closeModal,
        handleClickOut: closeModal,
        oneButtons: true,
        type: "WARNING",
      }));
      return;
    } else {
      if (name === "fotoPerfil") {
        setValidPhotoSize(true);
      }
      if (name === "hojaVida") {
        setValidCvSize(true);
      }
    }
    //Formato
    let formats = accept.toUpperCase().split(",");
    if (name === "fotoPerfil" && !formats.includes(file.type.toUpperCase())) {
      let question = "Solo se permiten archivos de tipo PDF, JPG, PNG, JPEG";

      setValidPhotoFormat(false);
      question = "Solo se permiten archivos de tipo PDF, JPG, PNG, JPEG";
      setConfirm(() => ({
        open: true,
        question,
        handleClick: closeModal,
        handleClickOut: closeModal,
        oneButtons: true,
        type: "WARNING",
      }));
      return;
    } else if (name === "hojaVida" && file.type !== "application/pdf") {
      setValidCvFormat(false);
      let question = "Solo se permiten archivos de tipo PDF";
      setConfirm(() => ({
        open: true,
        question,
        handleClick: closeModal,
        handleClickOut: closeModal,
        oneButtons: true,
        type: "WARNING",
      }));
      return;
    } else {
      if (name === "fotoPerfil") {
        setValidPhotoFormat(true);
      }
      if (name === "hojaVida") {
        setValidCvFormat(true);
      }
    }

    obtenerDataArhivo(file).then((respuesta) => {
      if (name === "fotoPerfil") {
        setDocumentos((anterior) => ({
          ...anterior,
          imagenPerfil: respuesta,
          photoExtension: file.type.split("/")[1],
        }));
        setValidPhoto(true);
      }

      if (name === "hojaVida") {
        setDocumentos((anterior) => ({
          ...anterior,
          hojaVida: respuesta,
        }));
        setValidCv(true);
      }
    });
  };

  const onChangeDate = (value) => {
    setMinDate(value);
  };

  const handleUserKeyPress = (e) => {
    let invalidChars = ["-", "e", "+", "E", ".", ","];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const validateText = (value) => {
    if (!value || value.length < 5) {
      return {
        hasError: true,
        message: "Ingrese mínimo 5 caracteres",
      };
    } else if (value.length > 50) {
      return {
        hasError: true,
        message: "Ingrese máximo 50 caracteres",
      };
    } else {
      let re = /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g;
      let result = re.exec(value);
      if (!result) {
        return {
          hasError: true,
          message: "Ingrese un nombre válido",
        };
      } else {
        return {
          hasError: false,
          message: "",
        };
      }
    }
  };

  const validateNullorEmpty = (value) => {
    if (!value) {
      return {
        hasError: true,
        message: "La fecha es requerida",
      };
    } else {
      return {
        hasError: false,
        message: "",
      };
    }
  };

  const handleChangeInput = (index, event, type) => {
    const values = [...listChildren];
    if (type === "text") {
      const { value } = event.target;
      values[index][event.target.name] = value;
      const validate = validateText(value);
      setErrorHijos((errorHijos) => ({
        ...errorHijos,
        [`hijos[${index}]nombre`]: validate.hasError,
        [`hijos[${index}]messageNombre`]: validate.message,
      }));
    } else {
      values[index]["birthDate"] = event;
      const validate = validateNullorEmpty(event);
      setErrorHijos((errorHijos) => ({
        ...errorHijos,
        [`hijos[${index}]fechaNacimiento`]: validate.hasError,
        [`hijos[${index}]messageFecha`]: validate.message,
      }));
    }
    setListChildren(values);
  };

  const handleChangeCompInput = (index, event) => {
    const values = [...listComplementaryStudies];
    const { value } = event.target;
    values[index] = value;

    if (value.length === 0) {
      setErrorEstudios({
        ...errorStudios,
        [`estudios[${index}]estudio`]: false,
        [`estudios[${index}]message`]: "",
      });
    }
    if (value.length > 0 && value.length <= 5) {
      setErrorEstudios({
        ...errorStudios,
        [`estudios[${index}]estudio`]: true,
        [`estudios[${index}]message`]: "Ingrese mínimo 5 caracteres",
      });
    } else if (value.length > 50) {
      setErrorEstudios({
        ...errorStudios,
        [`estudios[${index}]estudio`]: true,
        [`estudios[${index}]message`]: "Ingrese máximo 50 caracteres",
      });
    } else {
      let re = /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g;
      let result = re.exec(value);
      if (!result) {
        setErrorEstudios({
          ...errorStudios,
          [`estudios[${index}]estudio`]: true,
          [`estudios[${index}]message`]: "Ingrese un nombre válido",
        });
      } else {
        setErrorEstudios({
          ...errorStudios,
          [`estudios[${index}]estudio`]: false,
          [`estudios[${index}]message`]: "",
        });
      }
    }
    setListComplementaryStudies(values);
  };

  if (breadCrumb?.handleCreateCv) {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Hoja de vida",
      breadCrumbSubText: "Hoja de vida",
      index: 9,
      handleCreateCv: false,
      isEditCv: false,
      isCreateCv: true,
    });
    setTimeout(() => {
      createBtnContainer.current.click();
    }, 100);
  }

  if (breadCrumb?.handleCancelCv) {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Hoja de vida",
      breadCrumbSubText: "Hoja de vida",
      index: 9,
      handleCancelCv: false,
      isEditCv: false,
      isCreateCv: true,
    });
    setTimeout(() => {
      cancelBtnContainer.current.click();
    }, 100);
  }

  return (
    <React.Fragment>
      <ModalConfirmBase
        description={confirm.question}
        open={confirm.open}
        handleClick={confirm.handleClick}
        handleClickOut={confirm.handleClickOut}
        oneButtons={confirm.oneButtons}
        type={confirm.type}
        title={confirm.title}
        //oneButtons={confirm.oneButtons}
      />
      <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <Grid container spacing={1} className={classes.title}>
          <Grid item xs={12} md={6} lg={6}></Grid>
          <Grid item xs={12} md={6} lg={6} style={{ textAlign: "right" }}>
            <BorderRedButton
              onClick={cancelConfirm}
              ref={cancelBtnContainer}
              style={{ display: "none" }}
            >
              CANCELAR
            </BorderRedButton>
            &nbsp;&nbsp;
            <ColorButton
              type="submit"
              disabled={isLoading}
              ref={createBtnContainer}
              style={{ display: "none" }}
            >
              FINALIZAR
            </ColorButton>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                label="Primer nombre"
                name="firstName"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
                helperText={
                  errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                label="Segundo nombre"
                name="secondName"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("secondName") &&
                  errors["secondName"].message
                }
                helperText={
                  errors.hasOwnProperty("secondName") &&
                  errors["secondName"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                label="Primer apellido"
                name="surname"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("surname") &&
                  errors["surname"].message
                }
                helperText={
                  errors.hasOwnProperty("surname") && errors["surname"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                label="Segundo apellido"
                name="secondSurname"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("secondSurname") &&
                  errors["secondSurname"].message
                }
                helperText={
                  errors.hasOwnProperty("secondSurname") &&
                  errors["secondSurname"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("documentType") &&
                errors["documentType"].message
              }
            >
              <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                Tipo de Documento
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                style={{ backgroundColor: "#e0e0e0", borderRadius: "8px" }}
                label="Tipo de Documento"
                name="documentType"
                disabled={true}
                size="small"
                notched={true}
                onChange={(event) => alert(event.target.value)}
                inputProps={{
                  name: "documentType",
                  id: "outlined-select-documentType",
                }}
                as={
                  <Select>
                    {maestras.tipoDocumnetoIdentificacion.map((document) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={document.key}
                        value={document.key}
                      >
                        {document.value}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("documentType") &&
                  errors["documentType"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="text"
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                disabled={true}
                InputLabelProps={{ shrink: true }}
                label="Número de Documento"
                name="documentNumber"
                size="small"
                error={
                  !!errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message
                }
                helperText={
                  errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy"
                    label="Fecha de expedición *"
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    error={
                      !isDisabled &&
                      !!errors.hasOwnProperty("expeditionDate") &&
                      errors["expeditionDate"].message
                    }
                    helperText={
                      !isDisabled &&
                      errors.hasOwnProperty("expeditionDate") &&
                      errors["expeditionDate"].message
                    }
                    minDate={minDate ? minDate : "01.01.1900"}
                    minDateMessage={
                      minDate
                        ? "No puede ser menor a la fecha de nacimiento"
                        : "No puede ser menor a 1900"
                    }
                    maxDate={maxDate}
                    maxDateMessage={"No puede ser mayor a la fecha actual"}
                  />
                }
                control={control}
                className={classes.formField}
                name="expeditionDate"
                placeholder="Fecha de expedición *"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy"
                    onAccept={onChangeDate}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    label="Fecha de nacimiento"
                    InputLabelProps={{ shrink: true }}
                    maxDate={lastDayYear}
                    disabled={isDisabled}
                  />
                }
                control={control}
                className={classes.formField}
                disabled={true}
                name="dateBirth"
                placeholder="Fecha de nacimiento"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("gender") && errors["gender"].message
              }
            >
              <InputLabel htmlFor="outlined-select-gender" shrink={true}>
                Género *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                size="small"
                name="gender"
                render={(props) => (
                  <Select
                    label="Género *"
                    notched={true}
                    className={classes.formField}
                    inputProps={{
                      name: "stateId",
                      id: "outlined-select-gender",
                    }}
                    onChange={(e) => {
                      props.onChange(e);
                      onChangeGender(e);
                    }}
                    value={props.value}
                  >
                    {maestras.generos.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.key}
                        value={op.key}
                      >
                        {op.value}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText>
                {errors.hasOwnProperty("gender") && errors["gender"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              fullWidth
              style={{ marginTop: "0px" }}
              error={
                !!errors.hasOwnProperty("phone") && errors["phone"].message
              }
            >
              <InputLabel
                htmlFor="phone"
                style={{ zIndex: 2, marginTop: "-7px", paddingLeft: "10px" }}
              >
                No. Teléfono *
              </InputLabel>
              <Input
                id="phone"
                inputComponent={TextMaskCustom}
                // fullWidth
                variant="outlined"
                type="text"
                notched={true}
                inputRef={register}
                className={classes.formField}
                style={{ marginTop: "0px" }}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "0px",
                    fontSize: 14,
                    paddingLeft: "12px",
                  },
                }}
                onKeyPress={handleUserKeyPress}
                //onChange={onTelephoneChange}
                name="phone"
                size="small"
              />
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("phone") && errors["phone"].message}
              </FormHelperText>
              <FormHelperText style={{ color: "#f44336" }}>
                {!errors.hasOwnProperty("phone") &&
                  showTelephoneMessage &&
                  telephoneMessage}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              fullWidth
              style={{ marginTop: "0px" }}
              error={
                !!errors.hasOwnProperty("cellPhoneNumber") &&
                errors["cellPhoneNumber"].message
              }
            >
              <InputLabel
                htmlFor="cellPhoneNumber"
                style={{ zIndex: 2, marginTop: "-7px", paddingLeft: "10px" }}
              >
                No. Celular *
              </InputLabel>
              <Input
                id="cellPhoneNumber"
                inputComponent={TextMaskCustom}
                // fullWidth
                variant="outlined"
                type="text"
                notched={true}
                inputRef={register}
                className={classes.formField}
                style={{ marginTop: "0px" }}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "0px",
                    fontSize: 14,
                    paddingLeft: "12px",
                  },
                }}
                onKeyPress={handleUserKeyPress}
                //onChange={onTelephoneChange}
                name="cellPhoneNumber"
                size="small"
              />
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("cellPhoneNumber") &&
                  errors["cellPhoneNumber"].message}
              </FormHelperText>
              <FormHelperText style={{ color: "#f44336" }}>
                {!errors.hasOwnProperty("cellPhoneNumber") &&
                  showCellTelephoneMessage &&
                  telephoneMessage}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                disabled={true}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                //disabled={true}
                InputLabelProps={{ shrink: true }}
                label="Correo electrónico *"
                placeholder="ejemplo@correo.com"
                name="email"
                size="small"
                error={
                  !!errors.hasOwnProperty("email") && errors["email"].message
                }
                helperText={
                  errors.hasOwnProperty("email") && errors["email"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("stateId") && errors["stateId"].message
              }
            >
              <InputLabel htmlFor="outlined-select-stateId" shrink={true}>
                Departamento de residencia *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                size="small"
                name="stateId"
                render={(props) => (
                  <Select
                    label="Departamento de residencia *"
                    notched={true}
                    className={classes.formField}
                    inputProps={{
                      name: "stateId",
                      id: "outlined-select-stateId",
                    }}
                    onChange={(e) => {
                      props.onChange(e);
                      handleDepartamentos(e);
                    }}
                    value={props.value}
                  >
                    {deptos.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        {op.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText>
                {errors.hasOwnProperty("stateId") && errors["stateId"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("cityId") && errors["cityId"].message
              }
            >
              <InputLabel htmlFor="outlined-select-cityId" shrink={true}>
                Municipio de residencia *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                size="small"
                name="cityId"
                render={(props) => (
                  <Select
                    label="Municipio de residencia *"
                    notched={true}
                    className={classes.formField}
                    inputProps={{
                      name: "cityId",
                      id: "outlined-select-cityId",
                    }}
                    onChange={(e) => {
                      props.onChange(e);
                      setCiudad(e.target.value);
                    }}
                    value={props.value}
                  >
                    {cities.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        {op.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText>
                {errors.hasOwnProperty("cityId") && errors["cityId"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("maritalStatus") &&
                errors["maritalStatus"].message
              }
            >
              <InputLabel htmlFor="outlined-select-maritalStatus" shrink={true}>
                Estado Civil *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Estado Civil *"
                name="maritalStatus"
                size="small"
                notched={true}
                inputProps={{
                  name: "maritalStatus",
                  id: "outlined-select-maritalStatus",
                }}
                as={
                  <Select>
                    {maestras.estadoCivil.map((estadoCivil) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={estadoCivil}
                        value={estadoCivil}
                      >
                        {estadoCivil}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("maritalStatus") &&
                  errors["maritalStatus"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("shirtSize") &&
                errors["shirtSize"].message
              }
            >
              <InputLabel htmlFor="outlined-select-shirtSize" shrink={true}>
                Talla Camisa *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Talla Camisa *"
                size="small"
                name="shirtSize"
                notched={true}
                inputProps={{
                  name: "shirtSize",
                  id: "outlined-select-shirtSize",
                }}
                as={
                  <Select>
                    {maestras.tallaLetras.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={op}
                      >
                        {op}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />

              <FormHelperText>
                {errors.hasOwnProperty("shirtSize") &&
                  errors["shirtSize"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("pantSize") &&
                errors["pantSize"].message
              }
            >
              <InputLabel htmlFor="outlined-select-pantSize" shrink={true}>
                Talla Pantalón *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Talla Pantalón *"
                size="small"
                name="pantSize"
                notched={true}
                inputProps={{
                  name: "pantSize",
                  id: "outlined-select-pantSize",
                }}
                as={
                  <Select>
                    {tallaNumeros.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={op}
                      >
                        {op}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("pantSize") &&
                  errors["pantSize"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("shoeSize") &&
                errors["shoeSize"].message
              }
            >
              <InputLabel htmlFor="outlined-select-shoeSize" shrink={true}>
                Talla Calzado *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Talla Calzado *"
                size="small"
                name="shoeSize"
                notched={true}
                inputProps={{
                  name: "shoeSize",
                  id: "outlined-select-shoeSize",
                }}
                as={
                  <Select>
                    {maestras.tallaCalzado.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={op}
                      >
                        {op}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />

              <FormHelperText>
                {errors.hasOwnProperty("shoeSize") &&
                  errors["shoeSize"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <Controller
              render={(props) => (
                <Autocomplete
                  {...props}
                  size="small"
                  options={professions}
                  className={classes.formField}
                  getOptionLabel={(option) => option.occupation}
                  renderOption={(option) => <span>{option.occupation}</span>}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Profesión / Oficio *"
                      variant="outlined"
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          height: "12px",
                          borderRadius: "8px",
                          paddingBottom: "6.5px",
                          fontSize: 12,
                        },
                      }}
                      error={
                        !!errors.hasOwnProperty("professionId") &&
                        errors["professionId"].message
                      }
                      helperText={
                        errors.hasOwnProperty("professionId") &&
                        errors["professionId"].message
                      }
                    />
                  )}
                  onChange={(_, data) => {
                    props.onChange(data);
                  }}
                />
              )}
              name="professionId"
              control={control}
            />
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("levelEducation") &&
                errors["levelEducation"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-levelEducation"
                shrink={true}
              >
                Nivel de Formación *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Nivel de Formación *"
                name="levelEducation"
                size="small"
                notched={true}
                inputProps={{
                  name: "levelEducation",
                  id: "outlined-select-levelEducation",
                }}
                as={
                  <Select>
                    {maestras.nivelFormacion.map((nivelFormacion) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={nivelFormacion}
                        value={nivelFormacion}
                      >
                        {nivelFormacion}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("levelEducation") &&
                  errors["levelEducation"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("yearExpericence") &&
                errors["yearExpericence"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-yearExpericence"
                shrink={true}
              >
                Años de Experiencia *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Años de Experiencia *"
                size="small"
                name="yearExpericence"
                notched={true}
                inputProps={{
                  name: "yearExpericence",
                  id: "outlined-select-yearExpericence",
                }}
                as={
                  <Select>
                    {experienceYears.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={op}
                      >
                        {op}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("yearExpericence") &&
                  errors["yearExpericence"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("ownVehicle") &&
                errors["ownVehicle"].message
              }
            >
              <InputLabel htmlFor="outlined-select-ownVehicle" shrink={true}>
                ¿Tiene Vehículo Propio? *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="¿Tiene Vehículo Propio? *"
                size="small"
                name="ownVehicle"
                notched={true}
                inputProps={{
                  name: "ownVehicle",
                  id: "outlined-select-ownVehicle",
                }}
                as={
                  <Select>
                    {maestras.respuestaAfirmacionNegacion.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={op}
                      >
                        {op}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("ownVehicle") &&
                  errors["ownVehicle"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("currentlyWorking") &&
                errors["currentlyWorking"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-currentlyWorking"
                shrink={true}
              >
                ¿Trabaja Actualmente? *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="¿Trabaja Actualmente? *"
                size="small"
                name="currentlyWorking"
                notched={true}
                inputProps={{
                  name: "currentlyWorking",
                  id: "outlined-select-currentlyWorking",
                }}
                as={
                  <Select>
                    {maestras.respuestaAfirmacionNegacion.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={op}
                      >
                        {op}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />

              <FormHelperText>
                {errors.hasOwnProperty("currentlyWorking") &&
                  errors["currentlyWorking"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          justify="flex-end"
          style={{ marginTop: "15px", paddingRight: "12px" }}
        >
          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="subtitle2">
              Señor usuario, favor adjuntar de manera obligatoria los siguientes
              documentos en PDF:
            </Typography>
            <Typography variant="subtitle2">
              (1) Hoja de vida completa, (2) Foto a color fondo blanco de 3x4cm
            </Typography>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl variant="outlined" fullWidth size="small">
              <input
                color="#7EBDCE"
                accept="application/pdf"
                type="file"
                onChange={subirArchivo}
                id="icon-button-file-hv"
                style={{ display: "none" }}
                name="hojaVida"
              />
              <label htmlFor="icon-button-file-hv">
                <Button
                  variant="contained"
                  component="span"
                  className={classes.button}
                  size="large"
                  color="#7EBDCE"
                  style={{
                    backgroundColor: "#7EBDCE",
                    color: "#FFF",
                    height: "35px",
                    width: "100%",
                    fontSize: 12,
                  }}
                  endIcon={<PublishIcon />}
                >
                  {documentos?.hojaVida?.nombre
                    ? documentos?.hojaVida?.nombre
                    : "Hoja de vida"}
                </Button>
              </label>
            </FormControl>
            <FormHelperText style={{ color: "#f44336" }}>
              {!validCv && REQUIRED_MESSAGE}
            </FormHelperText>
            <FormHelperText style={{ color: "#f44336" }}>
              {!validCvFormat && FORMAT_MESSAGE_CV}
            </FormHelperText>
            <FormHelperText style={{ color: "#f44336" }}>
              {!validCvSize && SIZE_MESSAGE}
            </FormHelperText>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl variant="outlined" fullWidth size="small">
              <input
                color="#7EBDCE"
                accept="application/pdf,image/png,image/jpg,image/jpeg"
                type="file"
                onChange={subirArchivo}
                id="icon-button-file-photo"
                style={{ display: "none" }}
                name="fotoPerfil"
              />
              <label htmlFor="icon-button-file-photo">
                <Button
                  variant="contained"
                  component="span"
                  className={classes.button}
                  size="large"
                  color="#7EBDCE"
                  style={{
                    backgroundColor: "#7EBDCE",
                    color: "#FFF",
                    height: "35px",
                    width: "100%",
                    fontSize: 12,
                  }}
                  endIcon={<PublishIcon />}
                >
                  {documentos?.imagenPerfil?.nombre
                    ? documentos?.imagenPerfil?.nombre
                    : "Foto de perfil"}
                </Button>
              </label>
            </FormControl>
            <FormHelperText style={{ color: "#f44336" }}>
              {!validPhoto && REQUIRED_MESSAGE}
            </FormHelperText>
            <FormHelperText style={{ color: "#f44336" }}>
              {!validPhotoFormat && FORMAT_MESSAGE_PHOTO}
            </FormHelperText>
            <FormHelperText style={{ color: "#f44336" }}>
              {!validPhotoSize && SIZE_MESSAGE}
            </FormHelperText>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          style={{ marginTop: "40px", paddingRight: "12px" }}
        >
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("numberChildren") &&
                errors["numberChildren"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-numberChildren"
                shrink={true}
              >
                N° de Hijos *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                size="small"
                name="numberChildren"
                render={(props) => (
                  <Select
                    label=" N° de Hijos *"
                    notched={true}
                    className={classes.formField}
                    inputProps={{
                      name: "numberChildren",
                      id: "outlined-select-numberChildren",
                    }}
                    onChange={(e) => {
                      props.onChange(e);
                      onNumberChildrenChange(e);
                    }}
                  >
                    {childValues.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op}
                        value={op}
                      >
                        {op}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText>
                {errors.hasOwnProperty("numberChildren") &&
                  errors["numberChildren"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          {listChildren.map((kid, index) => (
            <>
              {index !== 0 && <Grid item xs={12} md={3} lg={3}></Grid>}
              <Grid item xs={12} md={3} lg={3}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    //required={true}
                    //inputProps={{ maxLength: 80 }}
                    label="Nombre"
                    name="name"
                    value={kid.name}
                    className={classes.formField}
                    inputProps={{
                      maxLength: 80,
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                        maxLength: 80,
                      },
                    }}
                    size="small"
                    onChange={(event) =>
                      handleChangeInput(index, event, "text")
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                </FormControl>
                <FormHelperText style={{ color: "#f44336" }}>
                  {errorHijos[`hijos[${index}]nombre`] &&
                    errorHijos[`hijos[${index}]messageNombre`]}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy"
                    label="Fecha de nacimiento"
                    //required={true}
                    invalidDateMessage={"Ingrese un formato de fecha válido"}
                    InputLabelProps={{ shrink: true }}
                    onChange={(event) =>
                      handleChangeInput(index, event, "date")
                    }
                    className={classes.formField}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    value={kid.birthDate}
                    name="birthDate"
                    placeholder="Fecha de nacimiento"
                    size="small"
                    maxDate={maxDate}
                    maxDateMessage={
                      "La fecha no puede ser mayor a la fecha actual"
                    }
                    minDate="01.01.1900"
                    minDateMessage={"La fecha no puede ser menor a 1900"}
                  />
                </MuiPickersUtilsProvider>
                <FormHelperText style={{ color: "#f44336" }}>
                  {errorHijos[`hijos[${index}]fechaNacimiento`] &&
                    errorHijos[`hijos[${index}]messageFecha`]}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} md={3} lg={3}></Grid>
            </>
          ))}
        </Grid>
        <Typography variant="subtitle2" style={{ marginTop: "15px" }}>
          Estudios complementarios
        </Typography>
        <Grid
          container
          spacing={3}
          //justify="flex-end"
          style={{ marginTop: "5px", paddingRight: "12px" }}
        >
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                label="Estudios Complementarios"
                name="complementaryStudies"
                size="small"
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("complementaryStudies") &&
                  errors["complementaryStudies"].message
                }
                helperText={
                  errors.hasOwnProperty("complementaryStudies") &&
                  errors["complementaryStudies"].message
                }
              />
            </FormControl>
          </Grid>
          {listComplementaryStudies.map((complementary, index) => (
            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  type="text"
                  variant="outlined"
                  label="Estudio complementario"
                  name={`estudios[${index}]estudio`}
                  value={complementary.index}
                  className={classes.formField}
                  inputProps={{
                    style: {
                      height: "18px",
                      borderRadius: "8px",
                      paddingBottom: "6.5px",
                      fontSize: 14,
                    },
                  }}
                  size="small"
                  onChange={(event) => handleChangeCompInput(index, event)}
                  InputLabelProps={{ shrink: true }}
                  error={
                    !!errors.hasOwnProperty(`estudios[${index}]estudio`) &&
                    errors[`estudios[${index}]estudio`].message
                  }
                  helperText={
                    errors.hasOwnProperty(`estudios[${index}]estudio`) &&
                    errors[`estudios[${index}]estudio`].message
                  }
                />
              </FormControl>
              <FormHelperText style={{ color: "#f44336" }}>
                {errorStudios[`estudios[${index}]estudio`] &&
                  errorStudios[`estudios[${index}]message`]}
              </FormHelperText>
            </Grid>
          ))}

          <Link
            href="#"
            onClick={addComplementaryStudy}
            variant="body2"
            style={{ paddingTop: "18px" }}
          >
            Agregar
          </Link>
        </Grid>
      </form>
      <Backdrop
        className={classes.backdrop}
        style={{ zIndex: "9999" }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default withRouter(CvForm);
